<template>
  <div>
   <el-card>
     <el-alert
    title="客户信息"
    type="success"
    description="由于客户数据过于巨大,该列表显示的数据为回调数据,仅仅为部分数据,仅供浏览!."
    show-icon>
     </el-alert>
   </el-card>
    <el-card :gutter="20">
      <el-row :gutter="20">
        <el-col :span="3">
          <el-button type="primary" icon="plus"  style="width: 100%" size="mini" @click="getSync">同步数据</el-button>
        </el-col>
        <el-col :md="8" :lg="4">
            <el-select size="small" v-model="params.corp_id" clearable placeholder="切换企业" @change="typesearch">
                <el-option v-for="item in corpList" :key="item.id" :label="item.title" size="mini" :value="item.id"> </el-option>
            </el-select>
        </el-col>
      </el-row>
   </el-card>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="id" ></el-table-column>
      <el-table-column prop="unionid" label="unionid" ></el-table-column>
       <el-table-column prop="name" label="姓名" ></el-table-column>
      <el-table-column prop="avatar" label="头像" >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
                 <img :src="scope.row.avatar" style="width:200px;height:200px;" :alt="scope.row.name">
                <div slot="reference" class="name-wrapper">
                  <img :src="scope.row.avatar" style="width:30px;height:30px;" :alt="scope.row.name">
                </div>
              </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="gender" label="男/女" >
        <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.gender == '1'" >男</el-tag>
            <el-tag type="info" v-else >女</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" >
        <template slot-scope="scope">
          <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
    </el-table>
     <div class="content-center content-top-padded">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
      </div>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getWxcustom ,getCropList,syncContact} from '../../api/workwx'
  export default {
    data () {
      return {  
        total_count: 0,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        params: {
          page: 1,
          pageSize: 20,
          corp_id:'',
        },
        catesList:[],
        corpList:[],
        loading:false,
        memberTagDialog: false,
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      // 获取企业列表
      getCropList(){    
        getCropList(this.params).then(res => {
          this.corpList = res.data.data.list
          this.params.corp_id = this.corpList[0].id
           this.getDataList()
          })
      },
      typesearch () {
        this.params.page = 1
        this.getDataList()
      },
      handleSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getDataList()
      },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      },
      getDataList () {
        this.loading = true
        getWxcustom({'corp_id':this.params.corp_id,page:this.params.page,pageSize:this.params.pageSize}).then(response => {
          console.log(response.data.data.list)
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.deplist = response.data.data.dep
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getSync(){
         this.$confirm('此操作将进行数据同步变更, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            if(this.params.corp_id==undefined || this.params.corp_id==null){
            this.$message({
              type: 'error',
              message: '请选择企业'
            })
            return false;
          }else{
            syncContact({'corp_id':this.params.corp_id}).then(res=>{
              this.$message({
                type: 'success',
                message: '已加入队列!'
              })
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消同步数据'
          });          
        });
      }
    },
    mounted () {
      this.getCropList()
     
 
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>


// WEBPACK FOOTER //
// contact.vue?4e26ddb2